import React from 'react';
import moment from 'moment';
import { TimeControlWithOptions } from '../../TimeControls/TimeControlWithOptions';

const CustomTime = ({ calendarState, time, timezone, onChange }) => {
  const getDisplayFormat = (dates) => {
    return dates.every((date) => new Date(date).getFullYear() === new Date().getFullYear())
      ? 'MMM D'
      : 'YYYY MMM D';
  };
  
  return (
    <div className="datepicker-custom-range__time-container">
      <div className="time-range__group">
        <div>
          {moment(calendarState[0].startDate).format(getDisplayFormat([calendarState[0].startDate]))}
        </div>
        
        <TimeControlWithOptions
          className={'time-control-with-options__datepicker'}
          interval={15}
          maxTime={
            calendarState[0].startDate && moment(calendarState[0].startDate).isSame(moment(), 'day')
              ? moment().tz(timezone).format('HH:mm:ss.SSS')
              : false
          }
          time={time[0]}
          onChange={(e) => onChange([`${e}:00.000`, time[1]])}
        />
      </div>
      
      <div>to</div>
      
      <div className="time-range__group">
        <div>
          {moment(calendarState[0].endDate !== null ? calendarState[0].endDate : new Date()).format(
            getDisplayFormat([calendarState[0].endDate])
          )}
        </div>
        
        <TimeControlWithOptions
          className={'time-control-with-options__datepicker'}
          interval={15}
          maxTime={
            calendarState[0].endDate && moment(calendarState[0].endDate).isSame(moment(), 'day')
              ? moment().tz(timezone).format('HH:mm:ss.SSS')
              : false
          }
          time={time[1] === '23:59:59.999' ? 'eod' : time[1]}
          startTime={
            calendarState[0].startDate &&
            calendarState[0].endDate &&
            moment(calendarState[0].startDate).isSame(moment(calendarState[0].endDate), 'day')
              ? time[0]
              : null
          }
          onChange={val => {
            const endTime = val === 'eod' ? '23:59:59.999' : `${val}:00.000`;
            onChange([time[0], endTime])
          }}
          hasEODOption
        />
      </div>
    </div>
  );
};

export default CustomTime;